import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _DASHBOARD_FIRST_LINE_COUNT = async (searchData = false) => {
  let url = ServiceUrl.DASHBOARD.FIRST_LINE_COUNT;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};
